/**
* 底部
*/ 
<template>
   <div class="footer">
      <div class="foot">
          <div class="left">
            <router-link class="a1" to="/story">About Us</router-link>
              <p class="p1">Follow Us & Enquiry</p>
              <div class="flbox">
               <div  v-for="item in follow" class="a2" @click="go(item.path)" :key="item.name">
              
                  <img :src="item.icon" alt="" class="icon">
               </div>
              </div>
          </div>
          <div class="right">
              <!-- <p class="p1">Join our mailing list</p>
              <input type="text" class="input1" name="" placeholder="Enter your email here*">
              <div class="subbtn">Subscribe Now</div> -->

              <div class="line">
                 <div class="icon"><svg data-bbox="20.001 19.999 159.999 160.001" viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape">
    <g>
        <path d="M25.431 180a5.434 5.434 0 0 1-5.152-7.149l15.044-45.129a75.21 75.21 0 0 1-7.035-31.88c.009-28.898 16.082-54.887 41.943-67.812 10.453-5.281 22.284-8.109 33.926-8.029h4.128c.1 0 .2.002.3.008 38.579 2.128 69.277 32.826 71.406 71.406.007.1.009.2.009.3v4.128a75.215 75.215 0 0 1-8.041 33.948c-12.915 25.84-38.904 41.911-67.814 41.922-10.911-.044-21.926-2.397-31.866-7.035L27.15 179.721a5.431 5.431 0 0 1-1.719.279zm78.544-149.136a64.286 64.286 0 0 0-28.866 6.873C52.927 48.821 39.158 71.089 39.149 95.86a64.298 64.298 0 0 0 6.873 29.033 5.434 5.434 0 0 1 .304 4.166l-12.309 36.922 36.923-12.307a5.43 5.43 0 0 1 4.168.305 64.272 64.272 0 0 0 28.852 6.873h.167c24.782-.009 47.049-13.781 58.125-35.938a64.344 64.344 0 0 0 6.885-29.043v-4.003c-1.89-32.927-28.079-59.116-61.007-61.005h-3.989l-.166.001z"></path>
    </g>
</svg></div>
                      <p class="p2" @click="go(follow[0].path)" style="cursor:pointer;">Chat with me!</p>
              </div>
              <div class="line">
                 <div class="icon"><svg data-bbox="20.001 20 159.998 160.001" viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape">
    <g>
        <path d="M159.449 180c-.634 0-1.26-.028-1.88-.084-23.876-2.589-47.047-10.815-67.108-23.8-18.6-11.798-34.717-27.886-46.564-46.495-13.03-20.074-21.274-43.307-23.811-67.147-1.027-11.366 7.334-21.371 18.631-22.39a20.688 20.688 0 0 1 1.839-.083h22.441l.2-.001c10.15 0 18.89 7.56 20.321 17.663a90.246 90.246 0 0 0 4.936 19.805c2.813 7.467.996 15.971-4.631 21.655l-6.441 6.426a114.027 114.027 0 0 0 36.943 36.871l6.414-6.404c5.713-5.642 14.238-7.457 21.73-4.642a90.695 90.695 0 0 0 19.778 4.916c10.37 1.462 17.968 10.383 17.747 20.778v22.335c.046 11.301-9.146 20.552-20.491 20.598l-.054-.001zM63.145 31.209l-.094.001H40.555c-.278 0-.555.013-.833.038-5.125.462-8.923 5.007-8.46 10.131 2.341 22.008 9.982 43.543 22.085 62.188 10.995 17.272 25.917 32.166 43.182 43.116 18.638 12.063 40.114 19.689 62.151 22.079.192.018.593.049.785.029 5.144-.022 9.321-4.223 9.3-9.366v-22.421a9.339 9.339 0 0 0-8.038-9.609 101.852 101.852 0 0 1-22.198-5.524 9.393 9.393 0 0 0-9.871 2.094l-9.477 9.46a5.614 5.614 0 0 1-6.746.909 125.228 125.228 0 0 1-46.989-46.9 5.592 5.592 0 0 1 .91-6.733l9.501-9.483c2.535-2.559 3.358-6.422 2.079-9.819a101.42 101.42 0 0 1-5.545-22.22c-.643-4.537-4.613-7.97-9.246-7.97z"></path>
    </g>
</svg></div>
                      <p class="p2">Call(852){{tel}}</p>
              </div>
              <div class="line">
                 <div class="icon"><svg data-bbox="20 35 159.999 130" viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape">
    <g>
        <path d="M160.062 165H39.936C28.942 165 20 156.055 20 145.058V54.943C20.001 43.946 28.943 35 39.936 35h120.125c10.994 0 19.938 8.946 19.938 19.943v90.116c0 10.996-8.944 19.941-19.937 19.941zM39.936 44.845c-5.565 0-10.093 4.53-10.093 10.098v90.116c0 5.568 4.528 10.097 10.093 10.097h120.125c5.567 0 10.095-4.529 10.095-10.097V54.943c0-5.568-4.528-10.098-10.095-10.098H39.936z"></path>
        <path d="M100 112.433a4.914 4.914 0 0 1-2.822-.89L22.1 58.975a4.922 4.922 0 0 1 5.643-8.065L100 101.502l72.257-50.591a4.922 4.922 0 0 1 5.643 8.065l-75.078 52.567a4.914 4.914 0 0 1-2.822.89z"></path>
    </g>
</svg></div>
                      <p class="p2" >{{email}}</p>
              </div>
          </div>
      </div>

      
  </div>
</template>
<script>
import { settings} from '../api/userMG'
export default {
  name: 'foot',
  data() {
    return {
      email:"",
      tel:'',
       follow:[
       {
          name:'whatsapp',
          path:'',
          icon:require("@/assets/img/whatsapp.png")
        },
        {
          name:'ins',
          path:'',
          icon:require("@/assets/img/ins.png")
        }
       ]
    }
  },
  // 創建完畢狀態(裏麵是操作)
  created() {
    this.getdata('whatsapp')
    this.getdata('ins')
    this.getdata2('email')
  this.getdata2('tel')
  },
  methods: {
    getdata2(parameter) {

  
  

settings(parameter)
.then(res => {
  this.loading = false

  if (res.data.code != 1) {
    this.$message({
      type: 'info',
      message: res.message
    })
  } else {
      let dd=res.data.data.data
    if(dd.length>0){
      let path=JSON.parse(dd[0].content)['val']

      this[parameter]=path
   
    }
 
     
  }
})
.catch(err => {
  this.loading = false
  this.$message.error('菜單加載失敗，請稍後再試！')
})
},
    go(url){
     
    
      window.open(url, '_blank');
    },
    getdata(parameter) {
 
     
     

      settings(parameter)
        .then(res => {
          this.loading = false
   
          if (res.data.code != 1) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
              let dd=res.data.data.data
            if(dd.length>0){
              let path=JSON.parse(dd[0].content)['val']

              this.follow.forEach(el=>{
                 if(el.name==dd[0].name){
                  el.path=path
                 }

              })
           
            }
         
             
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜單加載失敗，請稍後再試！')
        })
    }
     
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/footer.vue